import { TextProps } from '@chakra-ui/react';

export const TextMaxCards: TextProps = {
  color: 'black',
};
